import React from 'react'

import { Typography, ButtonBase } from '@material-ui/core'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import MenuIcon from '@material-ui/icons/Menu'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    button: {
      cursor: 'pointer',
      display: 'flex',
      flexDirection: 'column',
      width: '64px',
    },
    icon: {
      color: theme.palette.text.secondary,
      width: '24px',
      height: '24px',
    },
    text: {
      textTransform: 'uppercase',
      lineHeight: 1,
    },
  }),
)

interface MenuButtonProps {
  onOpenMenu?: () => void
}

const MenuButton: React.FC<MenuButtonProps> = ({ onOpenMenu }) => {
  const classes = useStyles()

  return (
    <ButtonBase disableRipple className={classes.button} onClick={onOpenMenu}>
      <MenuIcon className={classes.icon} />
      <Typography className={classes.text} variant="h6" color="textSecondary">
        Menú
      </Typography>
    </ButtonBase>
  )
}

export default MenuButton
